import React, { useCallback, useMemo } from 'react'
import { Button } from '~components/Button'
import * as Styled from './DropDownContent.styles'
import { TimeTuple, AMPM } from './TimePicker.types'
import { formatAMPM, formatTime, prefixWithZero } from './TimePicker.utils'

const hours = [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(prefixWithZero)
const minutes = Array.from(Array(59).keys())
  .filter(num => num % 30 === 0)
  .map(prefixWithZero)

const times = hours.flatMap(hour => minutes.map(minute => `${hour}:${minute}`))
const ampm: AMPM[] = ['AM', 'PM']

interface Props {
  time: TimeTuple
  onChange: (time: TimeTuple) => void
}
const DropDownContent: React.FC<Props> = ({ time, onChange }) => {
  const selectedTime = useMemo(() => formatTime(time), [time])
  const selectedAMPM = useMemo(() => formatAMPM(time), [time])

  const onChangeTime = useCallback(
    (newTime: string, ap: AMPM) => {
      const [hoursStr, minutesStr] = newTime.split(':')
      const newTuple: TimeTuple = [parseInt(hoursStr, 10), parseInt(minutesStr, 10), ap]

      onChange(newTuple)
    },
    [onChange],
  )

  return (
    <Styled.Container>
      <Styled.Column>
        {times.map(t => (
          <li key={t}>
            <Button
              variant={t === selectedTime ? 'outlined' : 'transparent'}
              color={t === selectedTime ? 'primary' : 'base'}
              size="small"
              onClick={() => onChangeTime(t, selectedAMPM)}>
              {t}
            </Button>
          </li>
        ))}
      </Styled.Column>
      <Styled.Column>
        {ampm.map(ap => (
          <li key={ap}>
            <Button
              variant={ap === selectedAMPM ? 'outlined' : 'transparent'}
              color={ap === selectedAMPM ? 'primary' : 'base'}
              size="small"
              onClick={() => onChangeTime(selectedTime, ap)}>
              {ap}
            </Button>
          </li>
        ))}
      </Styled.Column>
    </Styled.Container>
  )
}

export default DropDownContent
